/**
 * @packageDocumentation
 * @module      RoboticNetworkSummary.ts
 * @description Models summary information for a robotic network
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
export default class RoboticNetworkSummary {
    constructor(roboticNetworkId, roboticNetworkName, systemCount) {
        this.roboticNetworkId = roboticNetworkId || null;
        this.roboticNetworkName = roboticNetworkName || '';
        this.systemCount = systemCount || 0;
    }
    /**
     * Return a RoboticNetwork object, with systems, built from a JSON object that might be returned from the server.
     *
     * @param json JSON representation of a robotic network and its devices.
     */
    static fromJSON(json) {
        return new RoboticNetworkSummary(json.roboticNetworkId, json.roboticNetworkName, json.systemCount);
    }
}
//# sourceMappingURL=RoboticNetworkSummary.js.map